module.exports = __webpack_public_path__ + "img/cta1.3d910ac5.jpg";